import React, { useState } from "react";
import {useNavigate} from "react-router-dom"
const screens = [
  {
    title: "The Heart of Home Cooking",
    description:
      "Experience authentic recipes passed down through generations, crafted with love and tradition.",
    buttonText: "Discover More",
    image: "/brandLogo.png",
  },
  {
    title: "Premium Quality Ingredients",
    description:
      "We prioritize your health by using farm-fresh vegetables and hand-ground spices in every meal.",
    buttonText: "See Quality",
    image: "/premium.png",
  },
  {
    title: "Excellence at Your Doorstep",
    description:
      "Gourmet home-style meals delivered fresh and hot, exactly when you need them.",
    buttonText: "Get Started",
    image: "/delivery.png",
  },
];

function Splash() {
  const navigate = useNavigate()
  const [currentScreen, setCurrentScreen] = useState(0);

  const handleDotClick = (index) => {
    setCurrentScreen(index);
  };

  const handleNext = () => {
    if (currentScreen < screens.length - 1) {
      setCurrentScreen(currentScreen + 1);
    } else {
      // Logic to go to Login/Home
      console.log("Redirecting to login...");
    }
  };

  const screenData = screens[currentScreen];

  return (
    <div
      className="scr on"
      id="s-splash"
      style={{
        backgroundColor: "#1a1a1a",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <div
        className="sp-center"
        style={{ textAlign: "center", color: "#fff", padding: "20px" }}
      >
        {/* Logo Section */}
        <div className="sp-ring" style={{ marginBottom: "40px" }}>
          <img
            src={screenData.image}
            alt="Bahurani Kitchen"
            style={{
              height: "160px",
              width: "160px",
              borderRadius: "50%",
              border: "3px solid whitesmoke",
              padding: "5px",
            }}
          />
        </div>

        {/* Content Section with Key for simple re-render animation */}
        <div
          key={currentScreen}
          style={{ animation: "fadeIn 0.5s ease-in-out" }}
        >
          <h1
            style={{
              fontSize: "1.6rem",
              fontWeight: 600,
              color: "#fff",
              marginBottom: "12px",
              letterSpacing: "0.5px",
            }}
          >
            {screenData.title}
          </h1>

          <p
            style={{
              color: "rgba(255,255,255,0.7)",
              fontSize: "0.95rem",
              fontWeight: 300,
              maxWidth: "280px",
              margin: "0 auto 40px auto",
              lineHeight: 1.6,
            }}
          >
            {screenData.description}
          </p>
        </div>

        {/* Professional Pagination Dots */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "40px",
          }}
        >
          {screens.map((_, index) => (
            <div
              key={index}
              onClick={() => handleDotClick(index)}
              style={{
                width: index === currentScreen ? "24px" : "8px", 
                height: "8px",
                borderRadius: "10px",
                backgroundColor:
                  index === currentScreen ? "#fff" : "rgba(255,255,255,0.3)",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </div>

        <button
          className="btn btn-or au4"
          style={{
            padding: "13px 36px",
            borderRadius: 50,
            fontSize: "0.9rem",
            marginTop: 16,
          }}
          onClick={()=>navigate("/login")}
        >
          {screenData?.buttonText}
        </button>
      </div>

      {/* Inline CSS for the fade effect */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default Splash;
